import { createRouter, createWebHistory } from "vue-router";
import DisplayPosts from "./components/DisplayPosts.vue";
import Post from "./components/Post.vue";
import Setting from "./components/Setting.vue";

const routes = [
  { path: "/", name: "DisplayPosts", component: DisplayPosts },
  { path: "/post", name: "Post", component: Post },
  { path: "/setting", name: "Setting", component: Setting },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
